import { useCallback } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client'
import usersGetQuery, { UsersGetQueryResult } from '@queries/usersGetQuery'
import { ApiHookResult } from '@typings/ApiHooks'
import { UserApi } from '@typings/entities/User'
import { Criteria } from '@utils/queries/buildCriteria'

export const useLoadUserList = (skip: boolean, criteria: Criteria): ApiHookResult<UserApi[]> => {
  const {
    data,
    error,
    loading: isLoading,
  } = useQuery(usersGetQuery, {
    variables: { criteria },
    skip: skip || !criteria,
  })

  return {
    data: data?.usersGet?.results,
    isLoading,
    error,
  }
}

type GetUsersListProps = {
  criteria: Criteria
}

type UseLazyLoadUserListReturn = {
  getUsersList: ({ criteria }: GetUsersListProps) => Promise<UsersGetQueryResult>
  isLoading: boolean
}

export const useLazyLoadUserList = (): UseLazyLoadUserListReturn => {
  const [getUsers, { loading: isLoading }] = useLazyQuery(usersGetQuery, { fetchPolicy: 'no-cache' })

  const getUsersList = useCallback(({ criteria }: GetUsersListProps) => getUsers({ variables: { criteria } }), [getUsers])

  return {
    getUsersList,
    isLoading,
  }
}
